
import { ref, getCurrentInstance, onMounted } from 'vue';
import { isLogin, tinyLogin } from '@/common/login';
import { isTiny } from '~/common/utils';

export const useLogin = () => {
  const { proxy } = getCurrentInstance() as { proxy: any }

  const showLoginPopup = ref(false) // 是否展示登陆
  const isLoginStatus = ref(false) // 当前是否为登录

  const changeLoginStatus = (val: boolean, cb?: Function) => {
    isLoginStatus.value = val
    cb && cb()
  }

  const handleLoginPopupClose = () => {
    showLoginPopup.value = false
  }
  // 拉kwai
  const handleLoginPopupOpenkwai = (cb?: Function) => {
    showLoginPopup.value = false
    proxy.$bus.emit('launchApp', { callAppPath: 'home' })
  }

  const needCheckLogin = async(cb: Function) => {
    if (!isLoginStatus.value && !proxy.$store.state.isLogin) {
      if (isTiny() && !proxy.$store.state.isLogin) {
        await tinyLogin(proxy)
        typeof cb === 'function' && cb()
      } else if(!isLoginStatus.value) {
        showLoginPopup.value = true
      }
    } else {
      typeof cb === 'function' && cb()
    }
  }

  onMounted(() => {
    // 进入页面渲染时 校验当前登录态
    const { proxy } = getCurrentInstance() as { proxy: any }
    isLogin().then((res) => {
      isLoginStatus.value = res

    })
  })

  return {
    showLoginPopup,
    isLoginStatus,
    handleLoginPopupClose,
    changeLoginStatus,
    handleLoginPopupOpenkwai,
    needCheckLogin
  };
};

